/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedModelTacDto } from '../models/PagedModelTacDto';
import type { TacDto } from '../models/TacDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TacControllerService {
    /**
     * @returns PagedModelTacDto OK
     * @throws ApiError
     */
    public static list({
        page,
        size = 20,
        sort,
        searchTac,
    }: {
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
        searchTac?: string,
    }): CancelablePromise<PagedModelTacDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/tacs',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'searchTac': searchTac,
            },
        });
    }
    /**
     * @returns TacDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: TacDto,
    }): CancelablePromise<TacDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/tacs',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns TacDto OK
     * @throws ApiError
     */
    public static delete({
        id,
    }: {
        id: number,
    }): CancelablePromise<TacDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/tacs/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns TacDto OK
     * @throws ApiError
     */
    public static read({
        id,
    }: {
        id: number,
    }): CancelablePromise<TacDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/tacs/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns TacDto OK
     * @throws ApiError
     */
    public static update({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: TacDto,
    }): CancelablePromise<TacDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/tacs/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
